<template>
  <section v-if="solutions.length" class="solution-list"
    :class="{ 'solution-list--with-composer': issue.issueStatus === 0 }" :aria-label="$t('解决方案列表')">
    <div class="solution-list__intro">
      <header class="solution-list__header">
        <h3>{{ $t("解决方案") }}</h3>
        <span>{{ $t("{p0} 次提交", { p0: solutions.length }) }}</span>
      </header>
      <button v-if="olderRejected.length" type="button" class="solution-list__toggle"
        :aria-expanded="historyExpanded ? 'true' : 'false'"
        :aria-controls="`solution-history-${issue.issueId}`" @click="historyExpanded = !historyExpanded">
        <i :class="historyExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" aria-hidden="true"></i>
        {{ $t("{p0}历史方案 · {p1} 条", { p0: historyExpanded ? $t("收起") : $t("查看"), p1: olderRejected.length }) }}
      </button>
    </div>
    <div :id="`solution-history-${issue.issueId}`" class="solution-list__entries">
      <issue-solution-item v-for="solution in visibleSolutions" :key="solution.answerId || 'submitted-draft'"
        :solution="solution" :latest="solution === solutions[0]" :issue="issue" :user="user"
        :can-approve="canApprove" :review-busy="reviewBusy" @busy="reviewBusy = $event"
        @changed="$emit('changed', $event)" />
    </div>
  </section>
</template>

<script>
import IssueSolutionItem from './IssueSolutionItem.vue';
import { sortSolutions, isRejectedSolution } from '@/utils/issueSolutions';

export default {
  name: 'IssueSolutionList',
  components: { IssueSolutionItem },
  props: {
    issue: { type: Object, required: true },
    user: { type: Object, required: true },
    canApprove: Boolean,
  },
  data() { return { historyExpanded: false, reviewBusy: false }; },
  computed: {
    solutions() { return sortSolutions(this.issue.solutions); },
    olderRejected() { return this.solutions.slice(1).filter(isRejectedSolution); },
    visibleSolutions() {
      // Render oldest first, keeping actionable/accepted solutions visible when history is collapsed.
      return this.solutions.filter((solution, index) => this.historyExpanded || index === 0 || !isRejectedSolution(solution)).reverse();
    },
  },
};
</script>

<style scoped>
.solution-list { --solution-rail-left: -21px; margin-left: 20px; padding: 0 0 4px 21px; }
.solution-list--with-composer { --solution-tail-height: auto; --solution-tail-bottom: -4px; }
.solution-list__intro { position: relative; padding: 18px 0 16px; }
.solution-list__intro::before { content: ''; position: absolute; top: 0; bottom: 0; left: var(--solution-rail-left); width: 1px; background: var(--border-color); pointer-events: none; }
.solution-list__header { display: flex; align-items: center; justify-content: space-between; gap: 10px; }
.solution-list__header h3 { margin: 0; color: var(--text-regular); font-size: 12px; font-weight: 600; }
.solution-list__header span { color: var(--text-muted); font-size: 11px; }
.solution-list__entries { display: grid; gap: 20px; }
.solution-list__toggle { display: flex; align-items: center; gap: 6px; width: 100%; margin: 14px 0 0; padding: 5px 0; border: 0; background: transparent; color: var(--text-muted); font: inherit; font-size: 12px; text-align: left; cursor: pointer; }
.solution-list__toggle:hover { color: var(--primary-color); }
.solution-list__toggle:focus-visible { outline: 2px solid var(--primary-color); outline-offset: 3px; border-radius: 3px; }
@media (max-width: 768px) { .solution-list { --solution-rail-left: -19px; margin-left: 16px; padding-left: 19px; } }
</style>
